<template>
  <div>
    <script id="editor" type="text/plain"></script>
  </div>
</template>
<script>
export default {
  name: 'UE',
  data() {
    return {
      editor: null,
      config: {
          autoHeightEnabled: false, // 编辑器不自动被内容撑高
          // 初始容器高度
          initialFrameHeight: 300,
          // 初始容器宽度
          initialFrameWidth: '100%',
          // 上传文件接口
          serverUrl:process.env.VUE_APP_URL +'AppUser/UpdatePortraitAndCertificate',
          imageActionName:'images',
          imageFieldName: "images", /* 提交的图片表单名称 */
          imageMaxSize: 2048000, /* 上传大小限制，单位B */
          imageUrlPrefix: '', /* 图片访问路径前缀 */
          imagePathFormat:process.env.VUE_APP_URL +'/File/TemporaryFile/Uploads/images/{yyyy}{mm}{dd}/{time}{rand:6}',/* 上传保存路径,可以自定义保存路径和文件名格式 */
          imageAllowFiles: [".png", ".jpg", ".jpeg", ".gif", ".bmp"], /* 上传图片格式显示 */
          imageCompressEnable: true, /* 是否压缩图片,默认是true */
          imageManagerListPath:'/File/TemporaryFile/Uploads/images/',
          // 上传视频
          videoActionName: "images", /* 执行上传视频的action名称 */
          videoFieldName: "images", /* 提交的视频表单名称 */
          videoPathFormat: process.env.VUE_APP_URL +"/File/TemporaryFile/Uploads/images/{yyyy}{mm}{dd}/{time}{rand:6}", /* 上传保存路径,可以自定义保存路径和文件名格式 */
          videoUrlPrefix:"", /* 视频访问路径前缀 */
          videoMaxSize: 1024000000, /* 上传大小限制，单位B，默认100MB */
          videoAllowFiles: [
            ".flv", ".swf", ".mkv", ".avi", ".rm", ".rmvb", ".mpeg", ".mpg",
            ".ogg", ".ogv", ".mov", ".wmv", ".mp4", ".webm", ".mp3", ".wav", ".mid"], /* 上传视频格式显示 */
        },
    }
  },
  props: {
    defaultMsg: {
      type: String
    }
  },
  watch:{
    defaultMsg(newval,oldval){
      this.editor.setContent(newval);
    }
  },
  mounted() {
    const _this = this;
    this.editor = UE.getEditor('editor', this.config); // 初始化UE
    // this.editor.addListener("ready", function () {
    //   _this.editor.setContent(_this.defaultMsg); // 确保UE加载完成后，放入内容。
    // });
  },
  methods: {
    _beforeInsertImage(e){
      debugger;
    },
    getUEContent() { // 获取内容方法
      return this.editor.getContent()
    }
  },
  destroyed() {
    this.editor.destroy();
  }
}
</script>